module.exports = __webpack_public_path__ + "media/images/dashboard/img_1-e805b17a0c7788853795600cf9b95abd.jpg";